module.exports = __webpack_public_path__ + "img/6.00e77342.png";